import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button, DialogContentText, Modal, ModalProps } from '@p81-common/ui';
import { CircularProgress } from '@mui/material';

interface DeleteConfirmModalProps {
  open: ModalProps['open'];
  featureName: string;
  onConfirm: (event?: React.MouseEvent) => void;
  onCancel: (event?: React.MouseEvent) => void;
  isLoading?: boolean;
}

const DeleteConfirmModal = ({
  open,
  featureName,
  onConfirm,
  onCancel,
  isLoading = false
}: DeleteConfirmModalProps) => {
  const { t } = useTranslation(['activity']);

  return (
    <Modal
      id="deleteFeatureFlagModal"
      open={open}
      onClose={onCancel}
      dialogTitleProps={{
        children: t('activity:featureFlag.DELETE_FEATURE_FLAG')
      }}
      dialogContentProps={{
        children: (
          <DialogContentText>
            {t('activity:featureFlag.CONFIRM_DELETE', {
              name: featureName
            })}
          </DialogContentText>
        )
      }}
      dialogActionsProps={{
        children: (
          <>
            <Button
              variant="text"
              color="primary"
              onClick={onCancel}
              disabled={isLoading}
            >
              {t('activity:common.CANCEL')}
            </Button>
            <Button
              color="error"
              onClick={onConfirm}
              disabled={isLoading}
              startIcon={isLoading ? <CircularProgress size={16} /> : undefined}
            >
              {t('activity:featureFlag.DELETE')}
            </Button>
          </>
        )
      }}
    />
  );
};

DeleteConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  featureName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export default DeleteConfirmModal;
